import { Box, Flex, FlexProps, Heading, Image } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import { TalentDropdown } from './TalentDropdown';

interface Props extends FlexProps {
  logo: string;
  title: string;
  isAgencyEnabled?: boolean;
}

export const Header: React.FC<Props> = ({
  logo,
  title,
  isAgencyEnabled,
  ...props
}) => {
  // Roster pages (logged in) - show talent dropdown
  return (
    <>
      <LoggedOutHeader
        logo={logo}
        title={title}
        isAgencyEnabled={isAgencyEnabled}
        {...props}
      />
      <Flex
        flexDirection={{ base: 'column', lg: 'row' }}
        justifyContent="flex-end"
        alignItems={{ base: 'flex-start', lg: 'flex-end' }}
        gap={4}
      >
        <TalentDropdown />
      </Flex>
    </>
  );
};

export function LoggedOutHeader({
  logo,
  title,
  isAgencyEnabled,
  ...props
}: Props) {
  const router = useRouter();

  const isPublicPage = router.asPath.includes('/shared/');

  if (isPublicPage || !isAgencyEnabled) {
    // Public page - show title and logo
    return (
      <Flex
        flexDirection={{ base: 'column', lg: 'row' }}
        justifyContent="flex-end"
        alignItems={{ base: 'flex-start', lg: 'flex-end' }}
        gap={4}
      >
        <Flex justifyContent="flex-end" alignItems="center" gap={4} {...props}>
          {logo && (
            <Box width={12} height={12} borderRadius="full">
              <Image src={logo} alt={title} />
            </Box>
          )}
          <Heading as="h1" fontWeight="500" fontSize="5xl">
            {title}
          </Heading>
        </Flex>
      </Flex>
    );
  }
  return null;
}
